import { proxy, useSnapshot } from 'valtio'
import { useProxy } from 'valtio/utils'

import { getCookie } from '@/utils/cookie'
const { UMI_ENV } = process.env

interface user {
  avatarUrl?: string
  balance?: number
  memberExpireTime?: string
  memberStatus?: number
  mobileNo?: string
  nickname?: string
  userId?: number
  isBindWx?: boolean
  specialInfo?: object
  auths?:string[]
  channelType?:number
  benefitType?: number | null,
  oemFlag? : number
  skillToken?: string
  isSuperAdmin?: boolean
  loginSource?: string | null
}

interface stateInterface {
  userInfo: user
  isLogin: boolean
  isRecord: boolean
  showRewardPop: boolean,
  oemInfos?: {
    hideMenuPaths?: string[],
    logoUrl?: string,
  }
  bosInfo:any
  isOldVersion: boolean,
}

const defaultState: stateInterface = {
  userInfo: {
    oemFlag: UMI_ENV === 'dev'||/wai-c-web/i.test(window.location.hostname)||/wime-ai/i.test(window.location.hostname)? 0: 1,
    loginSource: '',
  },
  isLogin: getCookie('token') ? true : false,
  isRecord: false,
  showRewardPop: false,
  oemInfos: {
    logoUrl: 'https://cdn2.weimob.com/saas/saas-fe-sirius-orion-node/production/zh-CN/483/WAIlogo.webp',
    hideMenuPaths: [],
  },
  bosInfo:{},
  isOldVersion: !!window.localStorage.getItem('isOldVersion'),
}

export const baseState = proxy({
  ...defaultState,
})

export const useStore = () => {
  return useProxy(baseState)
}
export const setUserInfo = (data?: any) => {
  baseState.userInfo = data
  window.localStorage.setItem('userInfo', JSON.stringify(data))
}

export const setBosInfo = (data?: any) => {
  baseState.bosInfo = data
}
// useStore() 报错的话，用 localStorage
export const getUserInfo = () => {
  try {
    const { userInfo } = useStore()
    return userInfo
  } catch (err) {
    try {
      const userInfoStr = window.localStorage.getItem('userInfo')
      const userInfo = userInfoStr ? JSON.parse(userInfoStr) : {}
      return userInfo
    } catch (err) {
      return defaultState.userInfo
    }
  }
}

export const setShowRewardPop = (data?: any) => {
  baseState.showRewardPop = data
}

export const setIsLogin = (data?: any) => {
  baseState.isLogin = data
}
export const setIsRecord = (data?: any) => {
  baseState.isRecord = data
}

export const setOemInfos = (data?: any) => {
  baseState.oemInfos = data;
}

export const useBasePlatform = () => {
  const baseSnap = useSnapshot(baseState)

  return {
    baseSnap,
    baseState: baseState,
  }
}
